import { render, staticRenderFns } from "./emailFormInput.vue?vue&type=template&id=5f054f1e&"
import script from "./emailFormInput.vue?vue&type=script&lang=js&"
export * from "./emailFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports